var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepsicoChipsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16.0523,
    fill: "url(#pattern0_7284_55231)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7284_55231",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7284_55231",
    transform: "matrix(0.0209014 0 0 0.015625 -0.168844 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7284_55231",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEl0lEQVR4nOWbT2wUVRzHxz8xejRevHjXi1f/xKbQv66NILvzllqtpcjYLoViDSxigGJQ/jVwqFXLQtstbRGrQmwXawqxJkC6QrfbFhq6m1JpxHDhAAc4IV8yJWv3TRfmzcybvpnhJd/jzr7vZ76/N5N57ydJmoF07AzSMXhCl48DiYPzGmu/KekNpGM3hE+cl1J9NIBE5B4LgDOeTUCy7RYDgP5W4RPnpckfNSUQndQHkIrVC584L13soQGMd/2sD2Cqr1D4xHlpLKpJQPdGfQB/x17EpjqAyIum6W2N2Df9D3Zfvc5NO9KzqB0e/V/hsxeAieirugDUgeoP7ywmgDkI2/lC2HnlGgWgPj4KiXWABPYvNgBVV7ZuQxMnCFsmpykAewdO32YHEFzxuggAPCFsGLlEAehti3awA5CkJ0Dkq26F8NXMNYSyzK8fTmKosfFpZgAiy4AHBEvxd0IZWIWgjf8xI/F3ShmYhcAl/sxlcKrd/EuK+lsbIHCJf2YgEHjTNgCDbba8J2xIaFb/w0d6JLMDhDwFIt8QXQasSfh65l/KfF08iaGOjmdNA1AHiNwr2jhrErZOzVAAtv9x9q5kdYCQTVxKwEDNm01CeCJFAWg+cfK6dQBBfykXAAZr3kwSGkYnKQDdXT0D1gH4/S+Ljj1rEtafn6AA/Prd4c3WAVRUPC/aKGsS1sbHKACxloOvWQdAyDOiTbImoTaepACc+qbzBcsA1CHaIGsSQvF586okXgMOMMii07v2IJSVgscOAPLfoiA4G4CyCjjXAwxEgPIgNwDZEJwLQFkF/HVs/h2haz9XAKoG9zY5FIBSBcR/oF+SUjGg/hOuAFQ5D4CiufPZOnrA4wCUR5hXlfjJwwCUHLHPpYpyDwJQdO58tlZXegyAYsD8VD9Q9QFQWZ5bQeIyAApj7B+2l59LzZtdAkAxcOczunRUH0DXly4AoFQZN68eZRmN6ANo+dwFAHqbjX8hHj+ib15VwxoXAAjXAePHGc33Axe72cz/1qS/EDoCAJGB0GrgZERn0TsBjGtOcDxMF1qBTz922VOAyEBDLXBoNxBrBYY6gd8PAYPqUZVONuOqRlqBnfVs/2cHANjxSWzfZ8D57/XNn2sBtoTYr6sBAEKec+5H0ZqPgOgOYPjbhcb/bH6w4qsvQEauuSSPBrB8+UvWAaxc+YotADJ6Pwisqwa+CAHhGqC2yvy1CvJpAD5fsb0bI8RhKi6kAbxdwmFfQJbDwo2xyldKAygp6rMOgDhrc/SRereMBlBcMGvRPHHU9riuAn4awJK8/9SnmH0HJIgDVbSUhlBaWmMegCwfEG7IqMp8mnWgcMSceckZh6QMy7+CBrA07y4k6UnjAAh5Q7gZXmXgK1rzeMSfcCoDzMU/MCvcCL+ngbEygJvjn1FRgfkygJvjn1HZO5oyKGAvA1RXLnrDhO1Pg8J8tu8DmGuZWSfegFW9t4wGUFbC1jIDrzRN5dpnYGqaSnmkbW5B1yhr21zaI42Tl3/JAaCToXEy2XaL+YOl28TUOpuI3BM+UdvE0jw91n5T/ETtSsDC9vn7WNXt9qZFGm4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepsicoChipsIcon);
export default __webpack_public_path__ + "static/media/pepsico-chips-icon.7cb18f9906921f02397f4140d4bd3635.svg";
export { ForwardRef as ReactComponent };